import React from 'react'

import { Box, Text,Input, Table } from '@superlogica/design-system'
import { Search } from '@superlogica/design-system/Icons/superlogica'
import Pagination from 'components/Pagination/Pagination'
import { BoxTitleTable, BoxTabTable } from 'styles/global-style'

const View = ({
  isLoading,
  isError,
  setSearchCAdmValue,
  tableAdministradoras,
  columns,
  refetch , totalItems, itemsPerPage,setCurrentPage,currentPage, manualSort}) => {

  return (
    <>
      <BoxTabTable
        border
        borderColor="neutral300"
        bgColor="neutral0"
        paddingSize="xs"
        radius="md"
        className="flex align-center"
      >
        <BoxTitleTable paddingSize="none">
          <Text className="mr-xxxs">Agências</Text>
          <Text color="neutral400" size="body02">
          {`Exibindo ${tableAdministradoras.length}`}
          </Text>
        </BoxTitleTable>
        <Box paddingSize="none" className="ml-auto flex align-center">
          <Input
            name="search"
            className="ml-xxxs"
            type="text"
            label="Buscar pela licença..."
            onChange={(e) => {
              setSearchCAdmValue(e.target.value)
            }}
            rightIcon={<Search />}
          />
        </Box>
      </BoxTabTable>
      <Box border borderColor="neutral300" bgColor="neutral0" paddingSize="none" radius="xs">
        <Table
          loading={isLoading}
          error={isError}
          data={tableAdministradoras}
          columns={columns}
          tableName="administradoras"
          retry={refetch}
          manualSort={manualSort}
        />
      </Box>
      <BoxTabTable
        border
        borderColor="neutral300"
        bgColor="neutral0"
        paddingSize="xxs"
        radius="md"
        className="flex align-center"
      >
      <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </BoxTabTable>
    </>
  )
}

export default View
